import { Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDistanceRateTableDimensionPrompt extends Layout {
    labelEnterTableDimensions: Label;
    textboxDistance: Textbox;
    textboxDistanceInc: Textbox;
    textboxMaxDistance: Textbox;
    textboxMaxWeight: Textbox;
    textboxWeight: Textbox;
    textboxWeightInc: Textbox;
}
